import { Routes, Route, useNavigate } from "react-router-dom";
import InvestmentList from "./InvestmentList";
import "./Investments.css";

export default function Investments(){

  const nav = useNavigate();

  return (
    <div className="investments-wrap">

      <div className="investments-actions">
        <button className="btn btn-secondary" onClick={()=>nav("list")}>All Investments</button>
      </div>

      <Routes>
        <Route index element={<InvestmentList />} />
        <Route path="list" element={<InvestmentList />} />
      </Routes>

    </div>
  );
}
